export const truncateAccount = (
  account: string | undefined,
): string | undefined => {
  if (!account) {
    return;
  }

  return `${account.slice(0, 4)}...${account.slice(-4)}`;
};
